<app-navbar (toggleSidebarEvent)="toggleSidebar()"></app-navbar>

<mat-sidenav-container autosize>
  <mat-sidenav #sidenav mode="side" [opened]="isSidebarOpen$()"
    [ngStyle]="{ width: isSidebarOpen$() ? '260px' : '0px' }" [mode]="isMobile$() ? 'over' : 'side'">
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content class="px-4">
    <div class="pt-4">
      <xng-breadcrumb separator=">">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
          <ng-container>{{ breadcrumb | translate }}</ng-container>
        </ng-container>
      </xng-breadcrumb>
    </div>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-footer></app-footer>